import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Policies.css";

export default function WebsitePolicies() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="ijacna-policy-page-container">
      <header className="ijacna-policy-page-header">
        <h1>Website & Journal Policies</h1>
        <p>
          The International Journal of Advanced Communication and Network
          Applications (IJACNA) maintains transparency, integrity, and
          professionalism in all its publishing activities.
        </p>
      </header>

      <div className="ijacna-policy-links">
        <Link to="/usage-policy" className="ijacna-policy-link">
          Usage Policy →
        </Link>
        <Link to="/content-policy" className="ijacna-policy-link">
          Content Policies →
        </Link>
        <Link to="/privacy-policy" className="ijacna-policy-link">
          Privacy Policy →
        </Link>
      </div>
    </div>
  );
}
